/**
 * @generated SignedSource<<4da4a9e69455507b78ea043d01c416ee>>
 * @relayHash ec56a186e9c99aa776e39e2340852c09
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 19c419aecfc30d7c835859a9d6566be1a6a380e4207f52906ff7edfd14c64ebf

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type SavedViewUpdatesAsideAggRootQuery$variables = {
  containerId: string;
  directoryId: string;
  shouldFetchGoalsData: boolean;
  shouldFetchProjectsData: boolean;
};
export type SavedViewUpdatesAsideAggRootQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SavedViewSidebarColumnAgg">;
};
export type SavedViewUpdatesAsideAggRootQuery = {
  response: SavedViewUpdatesAsideAggRootQuery$data;
  variables: SavedViewUpdatesAsideAggRootQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "containerId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "directoryId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "shouldFetchGoalsData"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "shouldFetchProjectsData"
  }
],
v1 = {
  "kind": "Variable",
  "name": "containerId",
  "variableName": "containerId"
},
v2 = {
  "kind": "Variable",
  "name": "directoryId",
  "variableName": "directoryId"
},
v3 = [
  (v1/*: any*/),
  (v2/*: any*/)
],
v4 = [
  {
    "alias": "uuid",
    "kind": "ScalarField",
    "name": "id"
  },
  {
    "kind": "ScalarField",
    "name": "entityType"
  },
  {
    "kind": "ScalarField",
    "name": "id"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "SavedViewUpdatesAsideAggRootQuery",
    "selections": [
      {
        "args": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "kind": "Variable",
            "name": "shouldFetchGoalsData",
            "variableName": "shouldFetchGoalsData"
          },
          {
            "kind": "Variable",
            "name": "shouldFetchProjectsData",
            "variableName": "shouldFetchProjectsData"
          }
        ],
        "kind": "FragmentSpread",
        "name": "SavedViewSidebarColumnAgg"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SavedViewUpdatesAsideAggRootQuery",
    "selections": [
      {
        "condition": "shouldFetchGoalsData",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v3/*: any*/),
            "concreteType": "TownsquareDirectoryView",
            "kind": "LinkedField",
            "name": "goals_directoryViewById",
            "plural": false,
            "selections": (v4/*: any*/)
          }
        ]
      },
      {
        "condition": "shouldFetchProjectsData",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v3/*: any*/),
            "concreteType": "TownsquareDirectoryView",
            "kind": "LinkedField",
            "name": "projects_directoryViewById",
            "plural": false,
            "selections": (v4/*: any*/)
          },
          {
            "condition": "shouldFetchProjectsData",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": [
                  (v1/*: any*/),
                  {
                    "kind": "Variable",
                    "name": "directoryViewId",
                    "variableName": "directoryId"
                  }
                ],
                "concreteType": "TownsquareSearchExplanation",
                "kind": "LinkedField",
                "name": "projects_explainSearch",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "logSafeQuery"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "19c419aecfc30d7c835859a9d6566be1a6a380e4207f52906ff7edfd14c64ebf",
    "metadata": {},
    "name": "SavedViewUpdatesAsideAggRootQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "696506d9d0cea02ebaa180442945f608";

export default node;
